import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "giphy-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.4453 19.775H17.5547V11.443L19.7766 9.2211V21.9969H4.22342V2H12.5555L10.3336 4.22188H6.4453V19.775Z" }, null, -1),
    _createElementVNode("path", { d: "M17.5547 4.22188V6.44375H19.7766V8.66563H13.1109V2H15.3328V4.22188H17.5547Z" }, null, -1)
  ])))
}
export default { render: render }